// material-ui

import insertshippinglineicon from '../../../assets/images/insert-shipping-line.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const InsertShippinglineIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={insertshippinglineicon} alt="Insert Shipping line" width="22"  />
    );
};

export default InsertShippinglineIcon;